import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { SubscriptionExpirationComponent } from './subscription-expiration';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('unsubscription.subscription-expiration', {
            url: '/subscription-expiration',
            //                        ncyBreadcrumb: {
            //                            label: 'Subscription Expiration',
            ////                            parent: 'unsubscription.unsubscription-index'
            //                        },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Subscription Expiration'
            },
            'views': {
                'multiContentUnsubscription': {
                    template: '<subscription-expiration flex="100"></subscription-expiration>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const SubscriptionExpirationModule: string = ng
    .module('subscription-expiration', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('subscriptionExpirationComponent', SubscriptionExpirationComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/unsubscription/subscription-expiration/subscription-expiration.module.ts